import { ChangeEvent, KeyboardEvent } from 'react';
import MaskedTextField from './MaskedTextField';
import { SxProps } from '@mui/material';

interface ZipCodeFieldProps {
  id: string;
  value: string;
  name: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  isClearable?: boolean;
  setValue?: (value: string) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  sx?: SxProps;
  error?: boolean;
  required?: boolean;
}

function ZipCodeField({
  id,
  name,
  value,
  onChange,
  label,
  isClearable,
  setValue,
  disabled,
  fullWidth = true,
  onKeyDown,
  sx,
  ...other
}: ZipCodeFieldProps) {
  const mask = '#####';
  const hint = 'XXXXX';

  return (
    <MaskedTextField
      id={id}
      name={name}
      placeholder={hint}
      format={mask}
      value={value}
      onChange={onChange}
      label={label}
      isClearable={isClearable}
      onKeyDown={onKeyDown}
      disabled={disabled}
      setValue={setValue}
      fullWidth={fullWidth}
      sx={sx}
      {...other}
    />
  );
}

export default ZipCodeField;
